import { render, staticRenderFns } from "./NewDownload.vue?vue&type=template&id=3e55e6d8&scoped=true&"
import script from "./NewDownload.vue?vue&type=script&lang=js&"
export * from "./NewDownload.vue?vue&type=script&lang=js&"
import style0 from "./NewDownload.vue?vue&type=style&index=0&id=3e55e6d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e55e6d8",
  null
  
)

export default component.exports